import React from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '../i18n';
import './BeACreator.css';

const BeACreatorPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="be-a-creator-container">
      <div className="creator-header">
        <h1>{t('beCreator.heroTitle')}</h1>
        <p className="subtitle">{t('beCreator.heroSubtitle')}</p>
        <button className="cta-button primary" onClick={() => navigate('/register')}>
          {t('beCreator.heroCta')}
        </button>
      </div>

      <div className="benefits-section">
        <h2>{t('beCreator.benefitsTitle')}</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="icon">🚀</div>
            <h3>{t('beCreator.benefit.audienceTitle')}</h3>
            <p>{t('beCreator.benefit.audienceText')}</p>
          </div>
          <div className="benefit-card">
            <div className="icon">🏆</div>
            <h3>{t('beCreator.benefit.recognitionTitle')}</h3>
            <p>{t('beCreator.benefit.recognitionText')}</p>
          </div>
          <div className="benefit-card">
            <div className="icon">🛠️</div>
            <h3>{t('beCreator.benefit.toolsTitle')}</h3>
            <p>{t('beCreator.benefit.toolsText')}</p>
          </div>
          <div className="benefit-card">
            <div className="icon">🤝</div>
            <h3>{t('beCreator.benefit.communityTitle')}</h3>
            <p>{t('beCreator.benefit.communityText')}</p>
          </div>
        </div>
      </div>

      <div className="how-it-works-section">
        <h2>{t('beCreator.howItWorksTitle')}</h2>
        <div className="steps-container">
          <div className="step">
            <div className="step-number">1</div>
            <h4>{t('beCreator.step.signupTitle')}</h4>
            <p>{t('beCreator.step.signupText')}</p>
          </div>
          <div className="step-connector"></div>
          <div className="step">
            <div className="step-number">2</div>
            <h4>{t('beCreator.step.createTitle')}</h4>
            <p>{t('beCreator.step.createText')}</p>
          </div>
          <div className="step-connector"></div>
          <div className="step">
            <div className="step-number">3</div>
            <h4>{t('beCreator.step.recognizedTitle')}</h4>
            <p>{t('beCreator.step.recognizedText')}</p>
          </div>
        </div>
      </div>

      <div className="creator-footer-cta">
        <h2>{t('beCreator.footerTitle')}</h2>
        <p>{t('beCreator.footerText')}</p>
        <button className="cta-button large" onClick={() => navigate('/register')}>
          {t('beCreator.footerCta')}
        </button>
      </div>
    </div>
  );
};

export default BeACreatorPage;
